"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _styles = require("./styles");
var _IconSearch = _interopRequireDefault(require("../../icons/General/IconSearch"));
var _debounce = require("../utils/debounce");
var _format = require("../../utils/format");
var _IconErrorOutline = _interopRequireDefault(require("../../icons/General/IconErrorOutline"));
var _InfoButton = _interopRequireDefault(require("../InfoButton"));
var _IconHelp = _interopRequireDefault(require("../../icons/General/IconHelp"));
var _jsxRuntime = require("@emotion/react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/** @jsxImportSource @emotion/react */

const Input = /*#__PURE__*/_react.default.forwardRef(({
  onDebounceChange,
  debounceDelay,
  maxlength,
  height,
  info,
  infoPlacement = 'left',
  className,
  cardInput,
  variant,
  autoComplete,
  getFormattedNumber,
  updateValueOnChange = false,
  ...props
}, ref) => {
  const [value, setValueChanged] = (0, _react.useState)(props.value ? variant === 'formattedNumber' ? props.value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ') : props.value : '');
  const [inputDirty, setInputDirty] = (0, _react.useState)(false);
  const debouncedValue = (0, _debounce.useDebounce)(value, debounceDelay ? debounceDelay : 0);
  const type = props.type ? props.type : 'text';
  const handleFormatting = val => {
    if (props.format === 'price' && val) {
      const value = val.replace(/\u00a0/g, '').replace(/ /g, '');
      return (0, _format.getFormattedPrice)(value);
    }
    return val;
  };
  const handleNumberOnlyFormatting = val => {
    const onlyNumbers = val.replace(/[^\d\s]/g, '');
    getFormattedNumber && getFormattedNumber(onlyNumbers);
    return onlyNumbers;
  };
  const onInputChange = e => {
    setInputDirty(true);
    if (variant === 'formattedNumber') {
      setValueChanged(handleNumberOnlyFormatting(e.target.value));
    } else if (props.format) {
      setValueChanged(handleFormatting(e.target.value));
    } else {
      setValueChanged(e.target.value);
    }
    if (props.onChange && !props.disabled) {
      props.onChange(e);
    }
  };
  const handleBlur = e => {
    if (variant === 'formattedNumber') {
      const onlyNumbers = value.toString().replace(/[^\d]/g, '');
      const formatedNumbersWithSpace = onlyNumbers.replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
      setValueChanged(formatedNumbersWithSpace);
    }
    props.onBlur && props.onBlur(e);
  };
  const handleFocus = e => {
    if (variant === 'formattedNumber') {
      setValueChanged(value.toString().replaceAll(' ', ''));
    }
    props.onFocus && props.onFocus(e);
  };
  (0, _react.useEffect)(() => {
    if (props.reset) {
      setValueChanged('');
    }
  }, [props.reset]);
  (0, _react.useEffect)(() => {
    if (props.value && updateValueOnChange) {
      if (variant === 'formattedNumber') setValueChanged(handleNumberOnlyFormatting(props.value));else setValueChanged(props.value);
    }
  }, [props.value]);

  // Handle debounce
  (0, _react.useEffect)(() => {
    const handleDebounceChange = value => {
      if (onDebounceChange && inputDirty) {
        onDebounceChange(value);
      }
    };
    handleDebounceChange(debouncedValue);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [debouncedValue]);
  return (0, _jsxRuntime.jsxs)("div", {
    css: _styles.styles.relative,
    children: [(0, _jsxRuntime.jsxs)("label", {
      htmlFor: props.id,
      css: theme => [_styles.styles.default(theme), props.highlight && _styles.styles.highligted(height), type === 'search' && _styles.styles.searchLabel(theme), (props.invalid || props.invalidMessage) && _styles.styles.invalid(theme), height && _styles.styles.height(height)],
      className: className,
      children: [props.label && (0, _jsxRuntime.jsx)("span", {
        css: info && _styles.styles.pr4,
        children: props.label
      }), (0, _jsxRuntime.jsxs)("div", {
        css: theme => [_styles.styles.inputWrapper(theme)],
        children: [(0, _jsxRuntime.jsx)("input", {
          id: props.id,
          type: type === 'stealth' ? 'number' : type,
          ...(type !== 'password' && {
            value
          }),
          placeholder: props.placeholder,
          disabled: props.disabled,
          autoFocus: props.focus,
          onBlur: handleBlur,
          onFocus: handleFocus,
          onChange: onInputChange,
          maxLength: maxlength,
          ref: ref,
          name: props.name,
          "aria-describedby": props.invalidMessage ? 'input-error-message' : undefined,
          css: theme => [type === 'text' && _styles.styles.text(theme), type === 'search' && _styles.styles.search(theme), type === 'password' && _styles.styles.password(theme), type === 'number' && _styles.styles.number(theme), type === 'stealth' && _styles.styles.stealth(theme), props.disabled && _styles.styles.disabled(theme), cardInput && _styles.styles.cardInput(theme)],
          autoComplete: autoComplete,
          children: _react.default.Children.map(props.children, child => {
            if (!child) {
              return null;
            }
            return child;
          })
        }), type === 'search' && (0, _jsxRuntime.jsx)(_IconSearch.default, {})]
      }), props.invalidMessage && (0, _jsxRuntime.jsx)(_IconErrorOutline.default, {
        size: "16px"
      }), props.invalidMessage && (0, _jsxRuntime.jsx)("span", {
        id: "input-error-message",
        css: theme => [_styles.styles.errorMessage(theme), !props?.label && _styles.styles.errorMessageNoLabel],
        children: props.invalidMessage
      })]
    }), info && (0, _jsxRuntime.jsx)("span", {
      css: _styles.styles.infoButton,
      children: (0, _jsxRuntime.jsx)(_InfoButton.default, {
        icon: (0, _jsxRuntime.jsx)(_IconHelp.default, {
          primary: true
        }),
        place: infoPlacement,
        children: info
      })
    })]
  });
});
var _default = exports.default = Input;